import MainLogo from './logo.svg'

const Logo = () => {
  return (
    <img src={MainLogo} alt="A.N.K. Tours - Logo" className='px-4' />
  )
}

export default Logo